import { ExpandedRow } from '@app/components/various/Table';
import { Row } from '@tanstack/react-table';
import { Account, Buyer } from '@typings';
import { useTranslation } from 'react-i18next';

import { BuyersList } from '../BuyersList';

interface Props {
  row: Row<Omit<Account, 'buyers'> & { buyers: Buyer.Base[] }>;
}

export const AccountListSubRow = ({ row }: Props) => {
  const { t } = useTranslation(['buyers']);

  return (
    <ExpandedRow parentRow={row}>
      <div className="-mt-1 bg-white">
        <BuyersList
          title={t('buyers:buyers_in_account', { account: row.original.name })}
          accountId={row.original.account}
          buyers={row.original.buyers}
        />
      </div>
    </ExpandedRow>
  );
};
